// @ts-nocheck
/* eslint-disable */

exports.breakpoints = void 0;
var breakpoints = {
  xs: '480px',
  sm: '768px',
  md: '1024px',
  lg: '1367px',
  xl: '1600px'
};
exports.breakpoints = breakpoints;
